import { Box } from '@mui/material';
import type { ReactNode } from 'react';

/**
 * Default rich text element factories for react-intl.
 * These are automatically available in every FormattedMessage and intl.formatMessage() call.
 *
 * Usage in translation strings:
 *   "Hello <bold>world</bold>"
 *   "Sent to <colorPrimary>{email}</colorPrimary>"
 *   "First line.<br></br>Second line."
 */
export const defaultRichTextElements: Record<string, (chunks: ReactNode) => ReactNode> = {
  br: () => <br />,
  semibold: chunks => <Box component="span" sx={{
    fontWeight: 500
  }}>
      {chunks}
    </Box>,
  bold: chunks => <Box component="span" sx={{
    fontWeight: 'bolder'
  }}>
      {chunks}
    </Box>,
  light: chunks => <Box component="span" sx={{
    fontWeight: 'lighter'
  }}>
      {chunks}
    </Box>,
  colorPrimary: chunks => <Box component="span" sx={{
    color: 'text.primary'
  }}>
      {chunks}
    </Box>,
  colorSecondary: chunks => <Box component="span" sx={{
    color: 'text.secondary'
  }}>
      {chunks}
    </Box>,
  colorDisabled: chunks => <Box component="span" sx={{
    color: 'text.disabled'
  }}>
      {chunks}
    </Box>,
  colorError: chunks => <Box component="span" sx={{
    color: 'error.main'
  }}>
      {chunks}
    </Box>,
  colorSuccess: chunks => <Box component="span" sx={{
    color: 'success.main'
  }}>
      {chunks}
    </Box>
};